import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableStyleTwo } from '../styles';

export const InterestCalculatorTable = ({ values, isRebuttal }) => {
    const { t } = useTranslation();  

    return (
        <TableStyleTwo isRebuttal={isRebuttal}>
            <tbody>
            {
                values.map(({ label, value}) => (
                    <tr key={label}>
                        <td>{t(`interest_calculator.${label}`)}</td>
                        <td>{value}</td>
                    </tr>
                ))
            }
            </tbody>
        </TableStyleTwo>
    );
};

export default InterestCalculatorTable;